import { render, staticRenderFns } from "./ModuleStepList.vue?vue&type=template&id=366704bd&scoped=true&"
import script from "./ModuleStepList.vue?vue&type=script&lang=ts&"
export * from "./ModuleStepList.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleStepList.vue?vue&type=style&index=0&id=366704bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366704bd",
  null
  
)

export default component.exports